angular.module('statVehicleMake', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/stat-vehicle-make/stat-vehicle-make.module.js